/* =========================================================================
   LaVitaLife — behaviour. No dependencies, no build step.
   Every module guards for its own markup, so the same file serves every
   template and every Shopify section.
   ========================================================================= */
(function () {
  'use strict';

  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var onShopify = typeof window.Shopify !== 'undefined';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, currency) {
    return '$' + (cents / 100).toFixed(2) + ' ' + (currency || 'CAD');
  }

  /* ------------------------------------------------- scent theme (signature)
     Selecting a scent re-tints the whole document: ambient wash, water
     column, accent type. The buy button deliberately never changes. */
  function scentTheme() {
    var buttons = $$('[data-scent-set]');
    if (!buttons.length) return;

    var stage   = $('[data-scent-image]');
    var wordEls = $$('[data-scent-word]');
    var root    = document.documentElement;

    function currentLang() {
      var l = document.documentElement.getAttribute('lang') || 'en';
      return l.indexOf('zh') === 0 ? 'zh' : 'en';
    }

    function apply(btn) {
      var key = btn.getAttribute('data-scent-set');

      root.setAttribute('data-scent', key);
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });

      wordEls.forEach(function (el) {
        var next = btn.getAttribute('data-scent-word-' + currentLang())
                || btn.getAttribute('data-scent-label');
        if (!next || el.textContent === next) return;
        el.style.opacity = '0';
        window.setTimeout(function () {
          el.textContent = next;
          el.style.opacity = '1';
        }, reduced ? 0 : 180);
      });

      var src = btn.getAttribute('data-scent-img');
      var pos = btn.getAttribute('data-scent-pos');
      if (stage && src && stage.getAttribute('src') !== src) {
        if (reduced) {
          stage.src = src;
          if (pos) stage.style.objectPosition = pos;
          return;
        }
        stage.style.opacity = '0';
        window.setTimeout(function () {
          stage.src = src;
          if (pos) stage.style.objectPosition = pos;
          stage.style.opacity = '1';
        }, 200);
      }
    }

    if (stage) stage.style.transition = 'opacity .4s ease';
    wordEls.forEach(function (el) { el.style.transition = 'opacity .22s ease'; });

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { apply(btn); });
    });

    /* Switching language has to re-resolve the scent name in the headline. */
    window.LVL_reapplyScent = function () {
      var active = buttons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      if (active) apply(active);
    };

    var initial = buttons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    if (initial) apply(initial);
  }

  /* ----------------------------------------------------------- scroll reveal */
  function reveals() {
    var items = $$('.reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ sticky head */
  function stickyHead() {
    var head = $('[data-head]');
    if (!head) return;
    var tick = function () { head.classList.toggle('is-stuck', window.scrollY > 8); };
    tick();
    window.addEventListener('scroll', tick, { passive: true });
  }

  /* ------------------------------------------------------------- marquee dup
     Duplicate the track once so the -50% translate loops seamlessly. */
  function marquee() {
    $$('[data-marquee]').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.innerHTML += track.innerHTML;
      track.dataset.cloned = '1';
    });
  }

  /* ------------------------------------------------------------------- tabs */
  function tabs() {
    $$('[data-tabs]').forEach(function (group) {
      var btns = $$('[role="tab"]', group);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('aria-controls');
          btns.forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
          $$('[role="tabpanel"]', group.parentNode).forEach(function (panel) {
            panel.hidden = panel.id !== target;
          });
        });
      });
    });
  }

  /* -------------------------------------------------------------------- faq */
  function faq() {
    $$('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* -------------------------------------------------------------- mobile nav */
  function mobileNav() {
    var panel = $('[data-mobile-nav]');
    if (!panel) return;

    function set(open) {
      panel.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      $$('[data-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    }

    $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    $$('a', panel).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ------------------------------------------------------------------ toast */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ------------------------------------------------------------ cart drawer
     Talks to Shopify's AJAX API when it is there; falls back to an in-memory
     cart so the static preview behaves identically. */
  var mockCart = { items: [], total_price: 0, currency: 'CAD' };

  function cart() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    var scrim   = $('[data-scrim]');
    var body    = $('[data-cart-body]');
    var foot    = $('[data-cart-foot]');
    var countEl = $('[data-cart-count]');
    var threshold = parseInt(drawer.getAttribute('data-free-ship') || '6900', 10);

    function open(state) {
      drawer.classList.toggle('is-open', state);
      if (scrim) scrim.classList.toggle('is-open', state);
      document.body.style.overflow = state ? 'hidden' : '';
      if (state) {
        var close = $('[data-cart-close]', drawer);
        if (close) close.focus();
      }
    }

    function getCart() {
      if (!onShopify) return Promise.resolve(mockCart);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    function changeQty(key, qty) {
      if (!onShopify) {
        mockCart.items = mockCart.items
          .map(function (i) { return i.key === key ? Object.assign({}, i, { quantity: qty }) : i; })
          .filter(function (i) { return i.quantity > 0; });
        recalc();
        return Promise.resolve(mockCart);
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }

    function recalc() {
      mockCart.total_price = mockCart.items.reduce(function (sum, i) {
        return sum + i.price * i.quantity;
      }, 0);
    }

    function render(data) {
      var count = (data.items || []).reduce(function (n, i) { return n + i.quantity; }, 0);
      if (countEl) {
        countEl.textContent = count;
        countEl.hidden = count === 0;
      }
      if (!body) return;

      if (!count) {
        body.innerHTML = '<p class="drawer__empty" data-i18n="cart.empty">Nothing here yet. Every order ships free over $69.</p>';
        if (foot) foot.hidden = true;
        translate();
        return;
      }
      if (foot) foot.hidden = false;

      var left = Math.max(0, threshold - data.total_price);
      var pct  = Math.min(100, (data.total_price / threshold) * 100);

      var shipHtml =
        '<div class="ship-bar">' +
          '<p class="ship-bar__note">' +
            (left > 0
              ? 'Add ' + money(left, data.currency) + ' for free shipping'
              : 'Free shipping unlocked') +
          '</p>' +
          '<span class="ship-bar__track"><span class="ship-bar__fill" style="width:' + pct + '%"></span></span>' +
        '</div>';

      var itemsHtml = data.items.map(function (item) {
        return '' +
          '<div class="line-item">' +
            '<div class="line-item__media">' +
              (item.image ? '<img src="' + item.image + '" alt="" width="68" height="68" loading="lazy">' : '') +
            '</div>' +
            '<div>' +
              '<p class="line-item__name">' + item.product_title + '</p>' +
              (item.variant_title ? '<p class="line-item__opt">' + item.variant_title + '</p>' : '') +
              '<div class="qty">' +
                '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Reduce quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<p class="line-item__price">' + money(item.price * item.quantity, data.currency) + '</p>' +
          '</div>';
      }).join('');

      body.innerHTML = shipHtml + itemsHtml;

      var totalEl = $('[data-cart-total]');
      if (totalEl) totalEl.textContent = money(data.total_price, data.currency);

      $$('[data-qty]', body).forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeQty(btn.getAttribute('data-qty'), parseInt(btn.getAttribute('data-to'), 10)).then(render);
        });
      });
    }

    function add(payload, label) {
      if (!onShopify) {
        var key = payload.id + '';
        var found = mockCart.items.filter(function (i) { return i.key === key; })[0];
        if (found) {
          found.quantity += payload.quantity || 1;
        } else {
          mockCart.items.push({
            key: key,
            product_title: payload.title || 'Item',
            variant_title: payload.variant || '',
            price: payload.price || 0,
            quantity: payload.quantity || 1,
            image: payload.image || ''
          });
        }
        recalc();
        render(mockCart);
        open(true);
        toast(label || 'Added to bag');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: payload.id, quantity: payload.quantity || 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return getCart(); })
        .then(function (data) {
          render(data);
          open(true);
          toast(label || 'Added to bag');
        })
        .catch(function () { toast('That variant is unavailable right now.'); });
    }

    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    if (scrim) scrim.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) open(false);
    });

    /* Quick-add from product cards */
    $$('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        add({
          id: btn.getAttribute('data-id'),
          title: btn.getAttribute('data-title'),
          variant: btn.getAttribute('data-variant') || '',
          price: parseInt(btn.getAttribute('data-price') || '0', 10),
          image: btn.getAttribute('data-image') || '',
          quantity: 1
        }, btn.getAttribute('data-added-label'));
      });
    });

    /* Product form — one handler, whichever variant control is rendered. */
    var form = $('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var field = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
        add({
          id: field ? field.value : form.getAttribute('data-id'),
          title: form.getAttribute('data-title') || (document.querySelector('.pdp__title') || {}).textContent || 'Item',
          variant: (form.querySelector('[data-variant-name]') || {}).textContent || '',
          price: parseInt(form.getAttribute('data-price') || '0', 10),
          image: form.getAttribute('data-image') || '',
          quantity: 1
        });
      });
    }

    getCart().then(render);
  }

  /* --------------------------------------------------------------- wishlist */
  function wishlist() {
    $$('[data-wish]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!on));
      });
    });
  }

  /* ---------------------------------------------------------------- gallery */
  function gallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        main.src = thumb.getAttribute('data-full') || $('img', thumb).src;
      });
    });
  }

  /* --------------------------------------------------------- variant picker
     Keeps price, compare-at, name and image in step with the chosen variant.
     Only runs on the Shopify product template, which renders the controls. */
  function variantPicker() {
    var radios = $$('[data-variant-option]');
    var select = $('[data-variant-select]');
    if (!radios.length && !select) return;

    var priceEls = $$('[data-price]');
    var compareEl = $('[data-compare]');
    var nameEl = $('[data-variant-name]');
    var mainImg = $('[data-product-image]');
    var stickyBtn = $('[data-sticky-buy] [data-quick-add]');

    function apply(el) {
      var price = el.getAttribute('data-price');
      if (price) {
        priceEls.forEach(function (p) { p.textContent = price; });
      }

      var compare = el.getAttribute('data-compare');
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }

      if (nameEl) nameEl.textContent = el.getAttribute('data-name') || '';

      var src = el.getAttribute('data-image');
      if (mainImg && src && src.indexOf('//') > -1) mainImg.src = src;

      if (stickyBtn) stickyBtn.setAttribute('data-id', el.value);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { apply(radio); });
    });

    if (select) {
      select.addEventListener('change', function () {
        if (stickyBtn) stickyBtn.setAttribute('data-id', select.value);
      });
    }
  }

  /* ------------------------------------------------------------- sticky buy */
  function stickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-up', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ------------------------------------------------------------------ i18n
     Preview-only live switching. On Shopify the header renders the native
     localization form instead and this is a no-op. */
  function translate() {
    var dict = window.LVL_I18N;
    if (!dict) return;
    var lang = document.documentElement.getAttribute('lang') || 'en';
    var table = dict[lang] || {};

    $$('[data-i18n]').forEach(function (el) {
      var val = table[el.getAttribute('data-i18n')];
      if (val != null) el.innerHTML = val;
    });
    $$('[data-i18n-attr]').forEach(function (el) {
      el.getAttribute('data-i18n-attr').split(',').forEach(function (pair) {
        var bits = pair.split(':');
        var val = table[bits[1]];
        if (val != null) el.setAttribute(bits[0], val);
      });
    });
  }

  function i18n() {
    if (!window.LVL_I18N) return;
    var saved = null;
    try { saved = window.localStorage.getItem('lvl-lang'); } catch (err) { /* private mode */ }
    if (saved) document.documentElement.setAttribute('lang', saved);

    function sync() {
      var lang = document.documentElement.getAttribute('lang');
      $$('[data-lang]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-lang') === lang));
      });
      document.documentElement.classList.toggle('is-zh', lang !== 'en');
      translate();
      if (window.LVL_reapplyScent) window.LVL_reapplyScent();
    }

    $$('[data-lang]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lang = btn.getAttribute('data-lang');
        document.documentElement.setAttribute('lang', lang);
        try { window.localStorage.setItem('lvl-lang', lang); } catch (err) { /* ignore */ }
        sync();
      });
    });

    sync();
  }

  function init() {
    i18n();
    scentTheme();
    reveals();
    stickyHead();
    marquee();
    tabs();
    faq();
    mobileNav();
    cart();
    wishlist();
    gallery();
    variantPicker();
    stickyBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify's theme editor re-renders sections; re-bind when it does. */
  document.addEventListener('shopify:section:load', init);
})();
